import type { FileRouteParams } from '@jotta/types/schemas/FileRouteSchema'
import { EncodedRoutePath } from '@jotta/utils/path/EncodedRoutePath'
import moize from 'moize'

export const routeParamsToRoutePath = moize.shallow(
  ({ query = '', context, '*': splat, sortBy, viewMode }: FileRouteParams) => {
    if (context === 'search') {
      if (!query) {
        return new EncodedRoutePath('/web', context, viewMode, sortBy)
      }
      return new EncodedRoutePath(
        '/web',
        context,
        viewMode,
        sortBy,
        query,
        splat,
      )
    }
    return new EncodedRoutePath('/web', context, viewMode, sortBy, splat)
  },
  {
    maxSize: 100,
  },
)
